import { Assessment } from './assessment';
import { Layout, Vessel } from './exercise';
import { ExerciseType } from './scheduled-exercise';
import { Simulator } from './simulation';

interface ClassroomExercise {
  id?: string;
  name: string;
  type: ExerciseType;
}

export enum SimulationRole {
  Instructor = 'Instructor',
  Student = 'Student',
  Guest = 'Guest',
}

export enum ClassroomStudentStatus {
  Invited = 'Invited',
  Joined = 'Joined',
}

export interface Position {
  id: string;
  name: string;
  layoutId?: string;
  userId?: string;
  vesselId: string;
}

export interface ClassroomStudent {
  avatar?: string;
  id: string;
  name: string;
  role: SimulationRole;
  status: ClassroomStudentStatus;
}
export interface ClassroomUser {
  assessmentResult: Assessment[];
  classroomRole: SimulationRole;
  id: string;
  layoutName: string;
  name: string;
  position: string;
  userImage: string;
  vesselCode: string;
  vesselImage: string;
  vesselName: string;
}
export interface BaseClassroom {
  exercise: {
    adHoc: boolean;
    id: string;
    layouts: Layout[];
    name: string;
    title: string;
    type: ExerciseType;
    vessels: Vessel[];
  };
  id: string;
  positions: Position[];
  simulator: Pick<Simulator, 'name' | 'type'>;
  students: ClassroomStudent[];
  classroomUsers: ClassroomUser[];
}

export interface Classroom extends BaseClassroom {
  code: string;
}

export type ActiveClassroom = StudentClassroomSession | InstructorClassroomSession;

export interface StudentClassroomSession {
  exercise: ClassroomExercise;
  id: string;
  position?: string;
  role: SimulationRole.Student;
  status: ClassroomStudentStatus;
}

export interface InstructorClassroomSession {
  exercise: ClassroomExercise;
  id: string; // In practice same as exercise.id
  role: SimulationRole.Instructor;
}
